import ndiImg from "public/pocCloud/network-digital-twins.png";

export const INTRO_CONSTANTS = {
  title: "Network Digital Twin, Powered by OneMind",
  description: [
    "Simulate smarter. Operate safer. OneMind’s Network Digital Twin creates a cloud-based virtual replica of your physical network—allowing you to test, analyze, and optimize configurations without disrupting live operations. ",
    "Designed for network teams that need to move fast without taking risks, this digital twin enables real-time validation of performance, security policies, and architecture changes in a fully controlled environment.",
  ],
  points: [
    "Replicate Real-World Network Environments : Mirror complex infrastructures with accuracy to test upgrades, policies, and integrations.",
    "Optimize Configurations & Security : Fine-tune settings, validate segmentation, and improve security posture before pushing changes live.",
    "Predict & Prevent Network Failures : Use simulations and analytics to identify vulnerabilities and avoid downtime before it happens.",
  ],
  image: ndiImg,
};
